export default __webpack_public_path__ + "static/media/remove.f47d6392.svg";